<template>
    <Select v-model="buffer" clearable>
        <Option
            v-for="transformationType in transformationTypes"
            :key="transformationType.id"
            :value="transformationType.id"
            :label="transformationType.label"
        >
            <span>{{ transformationType.label }}</span>
            <span style="float: right; color: #ccc">{{
                transformationType.function
            }}</span></Option
        >
    </Select>
</template>

<script>
export default {
    props: {
        value: Number,
        transformationTypes: Array,
    },
    data() {
        return {
            buffer: this.value,
        };
    },
    watch: {
        buffer() {
            this.$emit("input", this.buffer);
        },
        value() {
            this.buffer = this.value;
        },
    },
};
</script>
